export default __webpack_public_path__ + "static/media/PET.a8a38b73.png";